export enum Color {
  Red = 'Red',
  Blue = 'Blue',
  Yellow = 'Yellow',
  Green = 'Green',
  Black = 'Black',
  White = 'White',
  Transparent = 'Transparent',
  RedTransparent = 'RedTransparent',
  BlueTransparent = 'BlueTransparent',
  YellowTransparent = 'YellowTransparent',
  GreenTransparent = 'GreenTransparent',
  BlackTransparent = 'BlackTransparent',
  WhiteTransparent = 'WhiteTransparent',
}

export interface Rgba {
  red: number;
  green: number;
  blue: number;
  alpha: number;
}
